const getters = {
  getMenuList: state => state.menuList,
  getCollectList: state => state.collectList,
  softwareInfo: state => state.userInfo,
  getPlatformList: state => {
    const shopInfo = state.userInfo ? state.userInfo.crmDataShopInfoList : []
    let list = [
      {
        label: '淘宝',
        value: 'TB',
      },
      {
        label: '京东',
        value: 'JD',
      },
      {
        label: '抖音',
        value: 'DY',
      },
    ];
    list = list.filter((item) => {
      return shopInfo.some((obj) => {
        return item.value == obj.platformCode;
      });
    });
    return list
  }
}
export default getters